var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "h-100 d-flex flex-column"
  }, [_c('div', [_vm._t("icon")], 2), _c('b-card-text', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.top",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    ref: "headerTextElement",
    staticClass: "header-text",
    attrs: {
      "title": _vm.headerOverflow ? _vm.headerText : ''
    }
  }, [_vm._v(" " + _vm._s(_vm.headerText) + " ")]), _c('b-card-text', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.top",
      modifiers: {
        "hover": true,
        "top": true
      }
    }],
    ref: "nameTextElement",
    staticClass: "name-text",
    attrs: {
      "title": _vm.nameOverflow ? _vm.nameText : ''
    }
  }, [_vm._v(" " + _vm._s(_vm.nameText) + " ")]), _c('b-card-text', {
    staticClass: "description-text"
  }, [_vm._t("description")], 2), _c('b-card-text', {
    staticClass: "date-row"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/event/icon/clock.svg"),
      "alt": "Clock icon"
    }
  }), _c('span', {
    staticClass: "date-text"
  }, [_vm._t("date")], 2)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }